import { render, staticRenderFns } from "./posts-grid.vue?vue&type=template&id=78ed1c7f&scoped=true&"
import script from "./posts-grid.vue?vue&type=script&lang=js&"
export * from "./posts-grid.vue?vue&type=script&lang=js&"
import style0 from "./posts-grid.vue?vue&type=style&index=0&id=78ed1c7f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed1c7f",
  null
  
)

export default component.exports